/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
function getNumericValue (c) {
    const code = c.charCodeAt(0)
    if (code >= 48 && code <= 57) return code - 48
    if (code >= 65 && code <= 90) return code - 48
    return 0
}

function validaCpfCnpj (val) {
    if (val.length == 14) {
        // logica de CPF
        var cpf = val.trim()

        cpf = cpf.replace(/\./g, '')
        cpf = cpf.replace('-', '')
        cpf = cpf.split('')

        var v1 = 0
        var v2 = 0
        var aux = false

        for (var i = 1; cpf.length > i; i++) {
            if (cpf[i - 1] != cpf[i]) {
                aux = true
            }
        }

        if (aux == false) {
            return false
        }

        for (var i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
            v1 += getNumericValue(cpf[i]) * p
        }

        v1 = ((v1 * 10) % 11)

        if (v1 == 10) {
            v1 = 0
        }

        if (v1 != getNumericValue(cpf[9])) {
            return false
        }

        for (var i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
            v2 += getNumericValue(cpf[i]) * p
        }

        v2 = ((v2 * 10) % 11)

        if (v2 == 10) {
            v2 = 0
        }

        if (v2 != getNumericValue(cpf[10])) {
            return false
        } else {
            return true
        }
    } else if (val.length == 18) {
        // logica de cnpj alfanumerico
        var cnpj = val.trim().toUpperCase()

        cnpj = cnpj.replace(/\./g, '')
        cnpj = cnpj.replace('-', '')
        cnpj = cnpj.replace('/', '')
        cnpj = cnpj.split('')

        var v1 = 0
        var v2 = 0
        var aux = false

        for (var i = 1; cnpj.length > i; i++) {
            if (cnpj[i - 1] != cnpj[i]) {
                aux = true
            }
        }

        if (aux == false) return false

        // Primeiro dígito verificador
        var pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        for (var i = 0; i < 12; i++) {
            v1 += getNumericValue(cnpj[i]) * pesos1[i]
        }

        v1 = (v1 % 11)

        if (v1 < 2) {
            v1 = 0
        } else {
            v1 = (11 - v1)
        }

        if (v1 != getNumericValue(cnpj[12])) return false

        // Segundo dígito verificador
        var pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        for (var i = 0; i < 13; i++) {
            v2 += getNumericValue(cnpj[i]) * pesos2[i]
        }

        v2 = (v2 % 11)

        if (v2 < 2) {
            v2 = 0
        } else {
            v2 = (11 - v2)
        }

        if (v2 != getNumericValue(cnpj[13])) {
            return false
        } else {
            return true
        }
    } else {
        return false
    }
}
export default {
    validaCpfCnpj
}



// WEBPACK FOOTER //
// ./src/assets/libs/cpfcnpj.js